import type { CookieCategoryDefinition, CookieCategoryId, CookieConsentPreferences } from './types';

export const COOKIE_CATEGORIES: CookieCategoryDefinition[] = [
  {
    id: 'essential',
    required: true,
    titleKey: 'cookie.category.essential.title',
    descriptionKey: 'cookie.category.essential.description',
  },
  {
    id: 'functional',
    required: false,
    titleKey: 'cookie.category.functional.title',
    descriptionKey: 'cookie.category.functional.description',
  },
  {
    id: 'analytics',
    required: false,
    titleKey: 'cookie.category.analytics.title',
    descriptionKey: 'cookie.category.analytics.description',
  },
];

export const DEFAULT_COOKIE_PREFERENCES: CookieConsentPreferences = {
  essential: true,
  functional: false,
  analytics: false,
};

export const ALL_COOKIE_PREFERENCES: CookieConsentPreferences = {
  essential: true,
  functional: true,
  analytics: true,
};

export function isCookieCategoryId(value: string): value is CookieCategoryId {
  return value === 'essential' || value === 'functional' || value === 'analytics';
}

export function normalizePreferences(
  partial?: Partial<CookieConsentPreferences>,
): CookieConsentPreferences {
  return {
    essential: true,
    functional: partial?.functional ?? false,
    analytics: partial?.analytics ?? false,
  };
}
